import { logger } from 'logger'
import { WindowSelections } from 'store/selection/selectionTypes'
import FileSaver from 'file-saver'
import { ActionLog } from '../store/system'

const logFields = (type: string, fields?: Record<string, any>) => ({
  type,
  ...fields
})

export const logService = {
  formatLogs: (error: string, stack: string, selections: WindowSelections) => {
    const selectionString = JSON.stringify(selections, null, 2)

    return `
Error
${error}

Stack Trace
${stack}

Selections
${selectionString}
    `.trim()
  },
  downloadLogs: (logs: string) => {
    const blob = new Blob([logs], { type: 'text/plain;charset=utf-8', endings: 'native' })
    FileSaver.saveAs(blob, `error-logs-${new Date().toISOString()}.txt`)
  },
  logErrors: (error: string, stack: string, currentSelections: WindowSelections, actionLog: ActionLog) => {
    console.group('The application has encountered an error.')

    logger.error(logFields('Error'), error)

    console.group(`Additional Info`)

    logger.error(logFields('Stack Trace', { stack }), stack)
    logger.error(logFields('Current Selections', { currentSelections }), JSON.stringify(currentSelections))
    logger.error('Last 10 Actions', actionLog)

    console.groupEnd()

    console.groupEnd()
  }
}
